<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <path
      d="M75.7078 84.7671C76.2104 84.7614 76.6904 84.558 77.044 84.2009C77.3976 83.8438 77.5963 83.3617 77.5971 82.8592V27.7888L62.4084 12.6001H24.4356C23.9321 12.6027 23.4503 12.8052 23.096 13.1629C22.7417 13.5207 22.5441 14.0045 22.5464 14.508V84.7671"
      fill="white"
    />
    <path
      d="M75.7078 84.7671C76.2104 84.7614 76.6904 84.558 77.044 84.2009C77.3976 83.8438 77.5963 83.3617 77.5971 82.8592V27.7888L62.4084 12.6001H24.4356C23.9321 12.6027 23.4503 12.8052 23.096 13.1629C22.7417 13.5207 22.5441 14.0045 22.5464 14.508V84.7671"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M77.6008 27.7908L62.4121 12.6001V25.8976C62.4129 26.4008 62.6133 26.883 62.9694 27.2385C63.3254 27.594 63.808 27.7937 64.3112 27.7937L77.6008 27.7908Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.73 22.0935H53.614"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.73 28.7432H53.614"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.73 35.385H67.8551"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.73 42.0337H67.8551"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.9189 48.6826H67.8553"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M53.6143 55.3284H67.8554"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M56.4629 61.9702H67.8554"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M57.4131 68.6111H67.8551"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M56.4629 75.2607H67.8554"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M75.7076 84.7671L24 84.7671"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.2344 47.731C32.5529 47.7312 36.7744 49.0119 40.3649 51.4113C43.9555 53.8108 46.7539 57.221 48.4063 61.2109C50.0587 65.2008 50.4909 69.591 49.6481 73.8265C48.8054 78.0619 46.7255 81.9524 43.6717 85.0058C40.6179 88.0592 36.7271 90.1385 32.4915 90.9807C28.256 91.8229 23.8658 91.3902 19.8761 89.7372C15.8865 88.0843 12.4766 85.2854 10.0777 81.6945C7.67875 78.1036 6.39854 73.882 6.39893 69.5635C6.39971 63.7729 8.70057 58.2197 12.7954 54.1254C16.8903 50.0311 22.4438 47.731 28.2344 47.731Z"
      fill="#D9EDE2"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.2348 52.4758C31.615 52.4754 34.9194 53.4775 37.7301 55.3552C40.5407 57.2328 42.7315 59.9019 44.0252 63.0247C45.3189 66.1475 45.6575 69.5839 44.9982 72.8991C44.3388 76.2144 42.7112 79.2597 40.321 81.6499C37.9308 84.04 34.8856 85.6677 31.5703 86.327C28.255 86.9864 24.8187 86.6478 21.6958 85.3541C18.573 84.0603 15.904 81.8696 14.0263 79.0589C12.1486 76.2482 11.1466 72.9438 11.147 69.5636C11.1475 65.0318 12.948 60.6858 16.1524 57.4813C19.3569 54.2768 23.703 52.4764 28.2348 52.4758Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.124 78.1132C24.4534 78.1125 23.8105 77.8457 23.3363 77.3715L18.2793 72.3126C17.8316 71.8335 17.5876 71.1991 17.599 70.5435C17.6104 69.8879 17.8763 69.2624 18.3404 68.7992C18.8045 68.336 19.4305 68.0714 20.0861 68.0612C20.7417 68.0511 21.3756 68.2963 21.8538 68.7449L25.124 72.0102L33.4463 63.6899C33.9204 63.2159 34.5635 62.9496 35.2339 62.9497C35.9044 62.9498 36.5473 63.2162 37.0214 63.6904C37.4954 64.1645 37.7616 64.8076 37.7615 65.478C37.7614 66.1485 37.495 66.7914 37.0209 67.2654L26.9098 77.3715C26.4362 77.8453 25.794 78.1121 25.124 78.1132Z"
      fill="#D9EDE2"
      stroke="#211F58"
      stroke-width="1.5"
    />
  </svg>
</template>
